/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import { EvidiaModal } from '@evidia/components';
import type { NotificationType } from '@evidia/shared';
import { Typography } from 'antd';
import { useState } from 'react';
import { useNotifications } from '../hooks/useNotifications';

const MAP_BODY: Record<NotificationType, string[]> = {
	GENERIC: ['----'],
	UNPAID_GROUP: [
		'Vážený uživateli,',
		'Rádi bychom Vás upozornili, že jsme dosud neobdrželi platbu za používání našeho programu na pro aktuální ubdobí.',
		'Abychom Vám mohli i nadále poskytovat naše služby bez přerušení, prosíme o úhradu nezaplacené částky co nejdříve. Pokud platba nebude provedena, Váš účet bude uzamčen a nebudete moci nadále využívat naše služby.',
	],
};

const NotificationsModal: React.FC = () => {
	const [loadingId, setLoadingId] = useState<string | undefined>();
	const { data: notifications, readNotification } = useNotifications();

	const firstNotification = notifications[0];

	const onOkClick = async () => {
		if (!firstNotification) {
			return;
		}
		setLoadingId(firstNotification.id);
		await readNotification(firstNotification.id);
	};

	return (
		<EvidiaModal
			open={!!firstNotification}
			onOk={onOkClick}
			cancelButtonProps={{
				style: { display: 'none' },
			}}
			okButtonProps={{
				loading: loadingId === firstNotification?.id,
			}}
			okText="Potvrzuji přečtení"
		>
			<Typography.Title level={4}>Důležité upozornění</Typography.Title>
			{MAP_BODY[firstNotification?.type]?.map((text, index) => (
				<Typography.Paragraph key={index}>{text}</Typography.Paragraph>
			))}
		</EvidiaModal>
	);
};

export default NotificationsModal;
